export enum ReportedIssueStatus {
    TO_SOLVE = 'TO_SOLVE',
    RESOLVED = 'RESOLVED',
    IN_PROGRESS = 'IN_PROGRESS',
}

export interface ReportedIssue {
    id: number;
    title: string;
    email: string;
    content: string;
    createdAt: string;
    resolved: boolean;
    resolvedAt?: string;
    attachments?: ReportedIssueAttachment[];
    status?: ReportedIssueStatus;
    role?: 'Administrator' | 'Użytkownik';
}

export interface ReportedIssueAttachment {
    id: number;
    fileName: string;
}
